import { TEST } from "../actions/types";
import testReducer from "../reducers/test";
import { removeBrokenLogics, validateLogics } from "../utills/logicUtils";

// Simple in-module lock to prevent modal spam
let taskLogicModalOpen = false;

export const TaskLogicVerificationMiddleware = (store) => (next) => (action) => {
  if (action.type !== TEST.UPDATE) return next(action);

  // Prevent recursion when we dispatch fix/rollback updates
  if (action.meta?.skipValidation) return next(action);

  const showScreener = JSON.parse(localStorage.getItem("showScreener") || "false");
  if (showScreener) return next(action);

  const prevTest = store.getState().test;
  const prevDataRef = prevTest?.data;

  // Compute next state (pre-reducer) to validate
  const nextTestState = testReducer(prevTest, action);
  const nextData = nextTestState?.data;
  const nextTasks = nextData?.tasks || [];

  // If no tasks, nothing to validate
  if (!nextTasks.length) return next(action);

  const logicValidationMap = validateLogics(nextTasks);
  const allValid = Object.values(logicValidationMap).every((i) => i.isValid);

  if (allValid) return next(action);

  // Avoid dispatching multiple modals while one is already open
  if (taskLogicModalOpen) return;

  taskLogicModalOpen = true;

  // Clone ONLY when needed
  const prevData = structuredClone(prevDataRef);

  store.dispatch({
    type: TEST.SHOW_UPDATE_CONFIRMATION_MODAL,
    payload: {
      confirmationFor: TEST.CONFIRMATION_FOR.TASK_LOGIC,
      show: true,
      errorMessage: logicValidationMap,

      onProceed: () => {
        taskLogicModalOpen = false;

        const updatedTasks = removeBrokenLogics(logicValidationMap, nextTasks);

        store.dispatch({
          type: TEST.UPDATE,
          meta: { skipValidation: true },
          payload: { data: { ...(nextData || {}), tasks: updatedTasks } },
        });
      },

      onCancel: () => {
        taskLogicModalOpen = false;

        store.dispatch({
          type: TEST.UPDATE,
          meta: { skipValidation: true },
          payload: { data: prevData },
        });
      },
    },
  });

  return;
};
